var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMaxVolume = function SvgIconMaxVolume(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 4.7v1.719a5.6 5.6 0 0 1 2.968 2.07q1.134 1.484 1.133 3.516t-1.133 3.515q-1.132 1.485-2.968 2.07v1.72q2.539-.626 4.14-2.579 1.641-1.992 1.68-4.726-.039-2.735-1.68-4.688Q16.22 5.325 13.68 4.7m2.07 7.305q0-1.134-.586-1.993a3.6 3.6 0 0 0-1.484-1.367v6.68a3.4 3.4 0 0 0 1.484-1.29q.586-.897.586-2.03M4.5 9.505v5h3.32l4.18 4.18V5.324l-4.18 4.18z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaxVolume);
export { ForwardRef as ReactComponent };